import styled from '@eduzz/houston-styles/styled';

interface IContainerProps {
  isClubeBlack: boolean;
}

export const Container = styled.div<IContainerProps>`
  background: ${props => (props.isClubeBlack ? '#242424' : '#122d44')};
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
export const LogoContainer = styled.div`
  margin: 25px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    height: 68.883px;
    width: 120px;
  }
`;
export const Main = styled.div`
  ul {
    margin-top: 28px;
    padding: 0;
    padding-bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;

    align-items: flex-start;
  }
`;
